import React from 'react';
import './Footer.css';
import hhmiLogo from '../images/HHMI-Logo-White.png';
import fbIcon from '../images/fb-icon.png';
import twitterIcon from '../images/tweet-icon.png';
import phoneIcon from '../images/phone-logo.png';
import addressIcon from '../images/address-icon.png';

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="footer-top" />
          </div>
          <div className="row">
            <div className="col-md-4 footer-left">
              <div className="region region-footer-left">
                <section id="block-block-2" className="block block-block clearfix">
                  <div className="row" id="footer-content">
                    <div className="footer-menu-left col-6">
                      <ul>
                        <li><a className="footer-link-left" href="https://www.janelia.org/about-us">About Janelia</a></li>
                        <li><a className="footer-link-left" href="https://www.janelia.org/you-janelia/careers">Careers</a></li>
                        <li><a className="footer-link-left" href="https://www.janelia.org/directions">Get Directions</a></li>
                      </ul>
                    </div>
                    <div className="footer-menu-right col-6">
                      <ul>
                        <li><a className="footer-link-left" href="https://www.janelia.org/news">News</a></li>
                        <li><a className="footer-link-left" href="https://www.hhmi.org/" target="blank">HHMI.org</a></li>
                      </ul>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div className="col-md-8 footer-right">
              <div className="region region-footer-right">
                <section id="block-block-3" className="block block-block clearfix">
                  <div id="footer-content-right">
                    <div className="d-none d-sm-none d-md-block">

                      <div className="footer-fb">
                        Find us: <a href="https://www.facebook.com/HHMIJRC" target="blank">
                          <img alt="facebook" src={fbIcon} />
                        </a>
                        <a href="https://twitter.com/HHMIJanelia" target="blank"><img alt="twitter" src={twitterIcon} /></a>
                      </div>
                      <div className="footer-phone"><a href="tel://+1-571-209-4000">571-209-4000</a></div>
                      <div className="footer-address">
                        <a href="https://maps.google.com/maps/ms?msid=210624397259558803833.0004f136bf37c0764ede3&amp;msa=0&amp;ll=39.071412,-77.464256&amp;spn=0.03495,0.066047&amp;iwloc=0004f136bf3b5386f784f" target="blank">19700 Helix Drive Ashburn, Virginia 20147</a>
                      </div>
                    </div>

                    <div className="d-block d-md-none row">
                      <div className="footer-fb col-3"><a href="https://maps.google.com/maps/ms?msid=210624397259558803833.0004f136bf37c0764ede3&amp;msa=0&amp;ll=39.071412,-77.464256&amp;spn=0.03495,0.066047&amp;iwloc=0004f136bf3b5386f784f" target="blank"><img alt="map to janelia" src={addressIcon} /></a></div>

                      <div className="footer-fb col-3"><a href="tel://+1-571-209-4000"><img alt="phone number" src={phoneIcon} /></a></div>
                      <div className="footer-fb col-3"><a href="https://www.facebook.com/HHMIJRC" target="blank"><img alt="facebook" src={fbIcon} /></a></div>

                      <div className="footer-fb col-3"><a href="https://twitter.com/HHMIJanelia" target="blank"><img src={twitterIcon} alt="twitter" /></a></div>

                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="footer-bottom">
              <div className="region region-footer-bottom">
                <section id="block-janelia7-blocks-janelia7-footer-copyright" className="block block-janelia7-blocks clearfix">
                  <div className="contact-us-footer d-none d-sm-block">
                    <a href="mailto:hipposeq@janelia.hhmi.org">Contact Us</a>
                  </div>

                  <div className="footer-logo">
                    <a className="copyright" href="https://www.hhmi.org" target="blank">
                      <img  alt="hhmi logo" src={hhmiLogo} />
                    </a>
                  </div>

                  <div className="footer-copyright">
                    <a className="copyright" href="https://www.hhmi.org" target="blank">Copyright
                      <span className="copyright-icon">© </span>
                      2015 Howard Hughes Medical Institute
                    </a>
                  </div>

                  <div className="contact-us-footer d-block d-sm-none">
                    <a href="mailto:hipposeq@janelia.hhmi.org">Contact Us</a>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx